(function() {
  var $9d30e43074dd3cc4$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("desktop-nav")) return;
    let activeNav = null;
    const TRANSITION = "opacity 0.4s ease, transform 0.25s ease";
    const getUnderlay = () => document.querySelector("[data-desktop-nav-underlay]");
    const showUnderlay = () => {
      const underlay = getUnderlay();
      if (!underlay) return;
      underlay.style.visibility = "visible";
      underlay.offsetHeight;
      underlay.style.opacity = "1";
    };
    const hideUnderlay = () => {
      const underlay = getUnderlay();
      if (!underlay) return;
      underlay.style.opacity = "0";
      const onEnd = () => {
        underlay.style.visibility = "hidden";
        underlay.removeEventListener("transitionend", onEnd);
      };
      underlay.addEventListener("transitionend", onEnd);
    };
    const lockScroll = () => document.documentElement.classList.add("overflow-hidden");
    const unlockScroll = () => document.documentElement.classList.remove("overflow-hidden");
    customElements.define("desktop-nav", class DesktopNav extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector("[data-desktop-nav-trigger]");
        this.meganav = this.querySelector("[data-desktop-nav-meganav]");
      }
      connectedCallback() {
        Object.assign(this.meganav.style, {
          overflow: "hidden",
          opacity: "0",
          visibility: "hidden",
          pointerEvents: "none",
          transition: TRANSITION
        });
        this.trigger.addEventListener("click", e => {
          this._handleTriggerClick();
        });
        if (!document._desktopNavUnderlayBound) {
          document._desktopNavUnderlayBound = true;
          document.addEventListener("click", e => {
            if (activeNav && e.target.closest("[data-desktop-nav-underlay]")) activeNav._close();
          });
        }
        document.addEventListener("click", e => {
          if (activeNav === this && !this.contains(e.target)) this._close();
        });
        document.addEventListener("keydown", e => {
          if (e.key === "Escape" && activeNav === this) this._close();
        });
      }
      _openFromClosed() {
        this.trigger.classList.add("is-active");
        showUnderlay();
        lockScroll();
        window.dispatchEvent(new CustomEvent("desktop-nav:toggle", {
          detail: {
            open: true
          }
        }));
        const targetH = this._naturalHeight();
        this.meganav.style.visibility = "visible";
        this.meganav.style.pointerEvents = "auto";
        this.meganav.offsetHeight;
        this.meganav.style.opacity = "1";
      }
      _openFromSwitch(prev) {
        prev.trigger.classList.remove("is-active");
        this.trigger.classList.add("is-active");
        const currentH = prev.meganav.offsetHeight;
        const targetH = this._naturalHeight();
        Object.assign(prev.meganav.style, {
          pointerEvents: "none",
          opacity: "0",
          transition: TRANSITION
        });
        Object.assign(this.meganav.style, {
          visibility: "visible",
          opacity: "0",
          pointerEvents: "auto",
          transition: TRANSITION
        });
        this.meganav.offsetHeight;
        this.meganav.style.opacity = "1";
      }
      _close() {
        if (activeNav === this) activeNav = null;
        this.trigger.classList.remove("is-active");
        hideUnderlay();
        unlockScroll();
        window.dispatchEvent(new CustomEvent("desktop-nav:toggle", {
          detail: {
            open: false
          }
        }));
        this.meganav.style.opacity = "0";
        this.meganav.style.pointerEvents = "none";
        const panel = this.meganav;
        const onEnd = () => {
          panel.style.visibility = "hidden";
          panel.removeEventListener("transitionend", onEnd);
        };
        this.meganav.addEventListener("transitionend", onEnd);
      }
      _handleTriggerClick() {
        if (activeNav === this) {
          this._close();
          return;
        }
        const prev = activeNav;
        activeNav = this;
        if (prev) this._openFromSwitch(prev); else this._openFromClosed();
      }
      _naturalHeight() {
        const panel = this.meganav;
        const snapshot = {
          height: panel.style.height,
          visibility: panel.style.visibility,
          opacity: panel.style.opacity,
          transition: panel.style.transition
        };
        Object.assign(panel.style, {
          height: "auto",
          visibility: "hidden",
          opacity: "0",
          transition: "none"
        });
        const h = panel.scrollHeight;
        Object.assign(panel.style, snapshot);
        return h;
      }
    });
  })();
})();